import HorairesModal from './HorairesModal.view';

export default HorairesModal;
